
"use strict";

// =====================================================
// REPORTES ISR
//
// Archivo:
// src/fronend/reportes/isr/reportesisr.js
//
// =====================================================


// =====================================================
// VARIABLES
// =====================================================

let registrosreportesisr = [];


// =====================================================
// ELEMENTOS DEL DOM
// =====================================================

const tbodyreportesisr =
    document.getElementById("tbodyreportesisr");

const buscarISR =
    document.getElementById("buscarISR");

const btnLimpiarBusquedaISR =
    document.getElementById("btnLimpiarBusquedaISR");

const btnPDFISR =
    document.getElementById("btnPDFISR");

const totalEmpleadosISR =
    document.getElementById("totalEmpleadosISR");

const totalISR =
    document.getElementById("totalISR");

const totalPagadoISR =
    document.getElementById("totalPagadoISR");


// =====================================================
// CARGAR REPORTE ISR
// =====================================================

async function cargarReporteISR() {

    try {

        // =================================================
        // ESTADO DE CARGANDO
        // =================================================

        tbodyreportesisr.innerHTML = `

            <tr>

                <td
                    colspan="9"
                    class="loading">

                    <div
                        class="spinner-border text-success me-2"
                        role="status">

                    </div>

                    Cargando reporte de descuento ISR...

                </td>

            </tr>

        `;


        // =================================================
        // CONSULTAR BACKEND
        // =================================================

        const respuesta = await fetch(
            "/reportesisr/listar"
        );


        // =================================================
        // VALIDAR RESPUESTA
        // =================================================

        if (!respuesta.ok) {

            throw new Error(
                "No se pudo obtener el reporte de ISR."
            );

        }


        // =================================================
        // CONVERTIR A JSON
        // =================================================

        const datos = await respuesta.json();


        console.log(
            "Reporte ISR:",
            datos
        );


        // =================================================
        // VALIDAR ARRAY
        // =================================================

        if (!Array.isArray(datos)) {

            throw new Error(
                "El servidor no devolvió una lista válida."
            );

        }


        // =================================================
        // GUARDAR REGISTROS
        // =================================================

        registrosreportesisr = datos;


        // =================================================
        // MOSTRAR TABLA
        // =================================================

        mostrarReporteISR(
            registrosreportesisr
        );


        // =================================================
        // ACTUALIZAR RESUMEN
        // =================================================

        actualizarResumenISR(
            registrosreportesisr
        );


    } catch (error) {

        console.error(
            "Error al cargar el reporte ISR:",
            error
        );


        // =================================================
        // MOSTRAR ERROR
        // =================================================

        tbodyreportesisr.innerHTML = `

            <tr>

                <td
                    colspan="9"
                    class="error-state">

                    <i
                        class="bi bi-exclamation-triangle-fill d-block">
                    </i>

                    <strong>
                        Error al cargar el reporte
                    </strong>

                    <div class="mt-2">

                        No se pudo obtener el reporte de ISR.

                    </div>

                </td>

            </tr>

        `;


        // =================================================
        // LIMPIAR RESUMEN
        // =================================================

        actualizarResumenISR([]);

    }

}


// =====================================================
// MOSTRAR REPORTE ISR
// =====================================================

function mostrarReporteISR(
    registros
) {

    // =================================================
    // VALIDAR SI HAY DATOS
    // =================================================

    if (
        !Array.isArray(registros) ||
        registros.length === 0
    ) {

        tbodyreportesisr.innerHTML = `

            <tr>

                <td
                    colspan="9"
                    class="empty-state">

                    <i
                        class="bi bi-inbox d-block">
                    </i>

                    <strong>
                        No hay registros de ISR
                    </strong>

                    <div class="mt-2">

                        No existen empleados con información
                        de descuento ISR.

                    </div>

                </td>

            </tr>

        `;

        return;
    }


    // =================================================
    // GENERAR FILAS
    // =================================================

    tbodyreportesisr.innerHTML = registros

        .map(
            (registro, indice) => {


                // =========================================
                // DATOS
                // =========================================

                const nombreEmpleado =
                    registro.NOMBREEMPLEADO ?? "N/A";

                const dpi =
                    registro.DPI ?? "N/A";

                const nombrePuesto =
                    registro.NOMBREPUESTO ?? "N/A";

                const nombreTecnologico =
                    registro.NOMBRETECNOLOGICO ?? "N/A";

                const salarioBase =
                    Number(
                        registro.SALARIOBASE
                    ) || 0;

                const isr =
                    Number(
                        registro.ISR
                    ) || 0;

                const pagoISR =
                    Number(
                        registro[
                            "PAGO DE DESCUENTO ISR"
                        ]
                    ) || 0;

                const fecha =
                    formatearFechaISR(
                        registro.FECHA
                    );


                // =========================================
                // INICIAL
                // =========================================

                const inicial =
                    nombreEmpleado
                        .trim()
                        .charAt(0)
                        .toUpperCase();


                // =========================================
                // FILA
                // =========================================

                return `

                    <tr>

                        <td>
                            ${indice + 1}
                        </td>


                        <td>

                            <div
                                class="d-flex align-items-center">

                                <span
                                    class="employee-avatar">

                                    ${inicial}

                                </span>

                                <span
                                    class="employee-name">

                                    ${escapeHTMLISR(
                                        nombreEmpleado
                                    )}

                                </span>

                            </div>

                        </td>


                        <td>

                            ${escapeHTMLISR(
                                String(dpi)
                            )}

                        </td>


                        <td>

                            ${escapeHTMLISR(
                                nombrePuesto
                            )}

                        </td>


                        <td>

                            ${escapeHTMLISR(
                                nombreTecnologico
                            )}

                        </td>


                        <td>

                            <span class="salary">

                                Q ${formatearNumeroISR(
                                    salarioBase
                                )}

                            </span>

                        </td>


                        <td>

                            <span class="isr">

                                ${formatearNumeroISR(
                                    isr
                                )}

                            </span>

                        </td>


                        <td>

                            <span class="pago-isr">

                                Q ${formatearNumeroISR(
                                    pagoISR
                                )}

                            </span>

                        </td>


                        <td>

                            ${fecha}

                        </td>

                    </tr>

                `;

            }
        )

        .join("");

}


// =====================================================
// ACTUALIZAR RESUMEN ISR
// =====================================================

function actualizarResumenISR(
    registros
) {

    // =================================================
    // TOTAL EMPLEADOS
    // =================================================

    const cantidadEmpleados =
        registros.length;


    // =================================================
    // TOTAL ISR
    // =================================================

    const sumaISR =
        registros.reduce(
            (
                total,
                registro
            ) => {

                return total +

                    (
                        Number(
                            registro.ISR
                        ) || 0
                    );

            },
            0
        );


    // =================================================
    // TOTAL PAGADO ISR
    // =================================================

    const sumaPagoISR =
        registros.reduce(
            (
                total,
                registro
            ) => {

                return total +

                    (
                        Number(
                            registro[
                                "PAGO DE DESCUENTO ISR"
                            ]
                        ) || 0
                    );

            },
            0
        );


    // =================================================
    // MOSTRAR DATOS
    // =================================================

    if (totalEmpleadosISR) {

        totalEmpleadosISR.textContent =
            cantidadEmpleados;

    }


    if (totalISR) {

        totalISR.textContent =
            `Q ${formatearNumeroISR(
                sumaISR
            )}`;

    }


    if (totalPagadoISR) {

        totalPagadoISR.textContent =
            `Q ${formatearNumeroISR(
                sumaPagoISR
            )}`;

    }

}


// =====================================================
// BUSCAR ISR
// =====================================================

function filtrarReporteISR() {

    const texto =
        buscarISR.value
            .trim()
            .toLowerCase();


    // =================================================
    // SIN TEXTO
    // =================================================

    if (texto === "") {

        mostrarReporteISR(
            registrosreportesisr
        );

        actualizarResumenISR(
            registrosreportesisr
        );

        return;
    }


    // =================================================
    // FILTRAR
    // =================================================

    const registrosFiltrados =
        registrosreportesisr.filter(
            (registro) => {

                const nombre =
                    String(
                        registro.NOMBREEMPLEADO ?? ""
                    ).toLowerCase();

                const dpi =
                    String(
                        registro.DPI ?? ""
                    ).toLowerCase();

                const puesto =
                    String(
                        registro.NOMBREPUESTO ?? ""
                    ).toLowerCase();

                const tecnologico =
                    String(
                        registro.NOMBRETECNOLOGICO ?? ""
                    ).toLowerCase();


                return (

                    nombre.includes(texto) ||

                    dpi.includes(texto) ||

                    puesto.includes(texto) ||

                    tecnologico.includes(texto)

                );

            }
        );


    // =================================================
    // MOSTRAR RESULTADOS
    // =================================================

    mostrarReporteISR(
        registrosFiltrados
    );


    // =================================================
    // ACTUALIZAR RESUMEN
    // =================================================

    actualizarResumenISR(
        registrosFiltrados
    );

}


// =====================================================
// LIMPIAR BÚSQUEDA
// =====================================================

function limpiarBusquedaISR() {

    buscarISR.value = "";


    mostrarReporteISR(
        registrosreportesisr
    );


    actualizarResumenISR(
        registrosreportesisr
    );


    buscarISR.focus();

}


// =====================================================
// FORMATEAR NÚMEROS
// =====================================================

function formatearNumeroISR(
    valor
) {

    return Number(
        valor || 0
    ).toLocaleString(
        "es-GT",
        {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    );

}


// =====================================================
// FORMATEAR FECHA
// =====================================================

function formatearFechaISR(
    fecha
) {

    if (!fecha) {

        return "N/A";

    }


    const fechaObjeto =
        new Date(fecha);


    if (
        Number.isNaN(
            fechaObjeto.getTime()
        )
    ) {

        return "N/A";

    }


    return fechaObjeto.toLocaleDateString(
        "es-GT",
        {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        }
    );

}


// =====================================================
// PROTEGER TEXTO HTML
// =====================================================

function escapeHTMLISR(
    texto
) {

    return String(texto)

        .replaceAll(
            "&",
            "&amp;"
        )

        .replaceAll(
            "<",
            "&lt;"
        )

        .replaceAll(
            ">",
            "&gt;"
        )

        .replaceAll(
            '"',
            "&quot;"
        )

        .replaceAll(
            "'",
            "&#039;"
        );

}


// =====================================================
// CARGAR LIBRERÍAS PDF
// =====================================================

function cargarLibreriasPDF() {

    return new Promise(
        (resolve, reject) => {

            // =============================================
            // jsPDF
            // =============================================

            if (
                typeof window.jspdf ===
                "undefined"
            ) {

                const scriptPDF =
                    document.createElement(
                        "script"
                    );

                scriptPDF.src =
                    "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";

                scriptPDF.onload =
                    cargarAutoTable;

                scriptPDF.onerror =
                    () => {

                        reject(
                            new Error(
                                "No se pudo cargar jsPDF."
                            )
                        );

                    };

                document.head.appendChild(
                    scriptPDF
                );

            } else {

                cargarAutoTable();

            }


            // =============================================
            // AUTO TABLE
            // =============================================

            function cargarAutoTable() {

                if (
                    typeof window.jspdf ===
                    "undefined"
                ) {

                    reject(
                        new Error(
                            "jsPDF no está disponible."
                        )
                    );

                    return;

                }


                if (
                    typeof window.jspdf.jsPDF
                        .prototype.autoTable ===
                    "function"
                ) {

                    resolve();

                    return;

                }


                const scriptAutoTable =
                    document.createElement(
                        "script"
                    );

                scriptAutoTable.src =
                    "https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.8.2/jspdf.plugin.autotable.min.js";

                scriptAutoTable.onload =
                    () => {

                        resolve();

                    };

                scriptAutoTable.onerror =
                    () => {

                        reject(
                            new Error(
                                "No se pudo cargar AutoTable."
                            )
                        );

                    };

                document.head.appendChild(
                    scriptAutoTable
                );

            }

        }
    );

}


// =====================================================
// GENERAR PDF ISR
// =====================================================

async function generarPDFISR() {

    try {

        // =================================================
        // VALIDAR DATOS
        // =================================================

        if (
            !Array.isArray(
                registrosreportesisr
            ) ||
            registrosreportesisr.length === 0
        ) {

            alert(
                "No hay datos para generar el PDF."
            );

            return;

        }


        // =================================================
        // CARGAR LIBRERÍAS
        // =================================================

        await cargarLibreriasPDF();


        // =================================================
        // CREAR DOCUMENTO
        // =================================================

        const {
            jsPDF
        } = window.jspdf;


        const documento =
            new jsPDF(
                {
                    orientation: "landscape",
                    unit: "mm",
                    format: "legal"
                }
            );


        // =================================================
        // FECHA DE GENERACIÓN
        // =================================================

        const fechaGeneracion =
            new Date().toLocaleDateString(
                "es-GT",
                {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric"
                }
            );


        // =================================================
        // ENCABEZADO
        // =================================================

        documento.setFont(
            "helvetica",
            "bold"
        );

        documento.setFontSize(
            18
        );

        documento.text(
            "CONSULTING S.A.",
            14,
            15
        );


        documento.setFontSize(
            13
        );

        documento.text(
            "Reporte de Descuento ISR de Empleados",
            14,
            23
        );


        documento.setFont(
            "helvetica",
            "normal"
        );

        documento.setFontSize(
            9
        );

        documento.text(
            `Fecha de generación: ${fechaGeneracion}`,
            14,
            30
        );


        documento.text(
            `Total de empleados: ${registrosreportesisr.length}`,
            14,
            35
        );


        // =================================================
        // TOTALES
        // =================================================

        const sumaISR =
            registrosreportesisr.reduce(
                (
                    total,
                    registro
                ) => {

                    return total +
                        (
                            Number(
                                registro.ISR
                            ) || 0
                        );

                },
                0
            );


        const sumaPagoISR =
            registrosreportesisr.reduce(
                (
                    total,
                    registro
                ) => {

                    return total +
                        (
                            Number(
                                registro[
                                    "PAGO DE DESCUENTO ISR"
                                ]
                            ) || 0
                        );

                },
                0
            );


        documento.text(
            `Total ISR: Q ${formatearNumeroISR(sumaISR)}`,
            100,
            30
        );


        documento.text(
            `Total descuento ISR: Q ${formatearNumeroISR(sumaPagoISR)}`,
            100,
            35
        );


        // =================================================
        // PREPARAR DATOS DE LA TABLA
        // =================================================

        const filasPDF =
            registrosreportesisr.map(
                (
                    registro,
                    indice
                ) => {

                    return [

                        indice + 1,

                        String(
                            registro.NOMBREEMPLEADO ??
                            "N/A"
                        ),

                        String(
                            registro.DPI ??
                            "N/A"
                        ),

                        String(
                            registro.NOMBREPUESTO ??
                            "N/A"
                        ),

                        String(
                            registro.NOMBRETECNOLOGICO ??
                            "N/A"
                        ),

                        `Q ${formatearNumeroISR(
                            Number(
                                registro.SALARIOBASE
                            ) || 0
                        )}`,

                        formatearNumeroISR(
                            Number(
                                registro.ISR
                            ) || 0
                        ),

                        `Q ${formatearNumeroISR(
                            Number(
                                registro[
                                    "PAGO DE DESCUENTO ISR"
                                ]
                            ) || 0
                        )}`,

                        formatearFechaISR(
                            registro.FECHA
                        )

                    ];

                }
            );


        // =================================================
        // CREAR TABLA PDF
        // =================================================

        documento.autoTable({

            startY: 42,

            head: [[

                "#",

                "Empleado",

                "DPI",

                "Puesto",

                "Departamento Tecnológico",

                "Salario Base",

                "ISR",

                "Pago de Descuento ISR",

                "Fecha"

            ]],

            body:
                filasPDF,


            // =============================================
            // CONFIGURACIÓN
            // =============================================

            theme:
                "grid",


            styles: {

                font:
                    "helvetica",

                fontSize:
                    7,

                cellPadding:
                    2,

                valign:
                    "middle"

            },


            headStyles: {

                fontStyle:
                    "bold",

                halign:
                    "center"

            },


            columnStyles: {

                0: {
                    cellWidth: 8,
                    halign: "center"
                },

                1: {
                    cellWidth: 38
                },

                2: {
                    cellWidth: 30
                },

                3: {
                    cellWidth: 30
                },

                4: {
                    cellWidth: 40
                },

                5: {
                    cellWidth: 28,
                    halign: "right"
                },

                6: {
                    cellWidth: 22,
                    halign: "right"
                },

                7: {
                    cellWidth: 32,
                    halign: "right"
                },

                8: {
                    cellWidth: 24,
                    halign: "center"
                }

            },


            // =============================================
            // REPETIR ENCABEZADO
            // =============================================

            showHead:
                "everyPage",


            // =============================================
            // PIE DE PÁGINA
            // =============================================

            didDrawPage:
                function(data) {

                    const pagina =
                        documento.internal.getNumberOfPages();


                    documento.setFontSize(
                        8
                    );

                    documento.setFont(
                        "helvetica",
                        "normal"
                    );


                    documento.text(
                        `Consulting S.A. - Reporte de Descuento ISR`,
                        14,
                        documento.internal.pageSize.height - 8
                    );


                    documento.text(
                        `Página ${pagina}`,
                        documento.internal.pageSize.width - 25,
                        documento.internal.pageSize.height - 8
                    );

                }

        });


        // =================================================
        // GUARDAR PDF
        // =================================================

        documento.save(
            "Reporte_Descuento_ISR_Empleados.pdf"
        );


    } catch (error) {

        console.error(
            "Error al generar PDF ISR:",
            error
        );


        alert(
            "No se pudo generar el PDF del reporte ISR."
        );

    }

}


// =====================================================
// EVENTO BUSCAR
// =====================================================

if (buscarISR) {

    buscarISR.addEventListener(
        "input",
        filtrarReporteISR
    );

}


// =====================================================
// EVENTO LIMPIAR
// =====================================================

if (btnLimpiarBusquedaISR) {

    btnLimpiarBusquedaISR.addEventListener(
        "click",
        limpiarBusquedaISR
    );

}


// =====================================================
// EVENTO PDF
// =====================================================

if (btnPDFISR) {

    btnPDFISR.addEventListener(
        "click",
        generarPDFISR
    );

}


// =====================================================
// CARGAR AL INICIAR
// =====================================================

document.addEventListener(
    "DOMContentLoaded",
    () => {

        cargarReporteISR();

    }
);

